<template>
    <div>
      <div class="row">
          <div class="col-md-12">


              <div class="card abtg__default-card abtg__default-card-border" v-show="showAuctionListCard">
                  <div class="card-head">

                      <header>{{$t('auction.table_archive_title')}} <span class="abtg__focus-title">{{city}} </span>
                      </header>
                      <div class="abtg__header_popover">
                          <popover module="auction" content="list" position="right"></popover>
                      </div>
                      <div class="tools">

                          <a @click="openModal()" class="btn btn-default shadow-none abtg__btn-tool abtg__btn-star" >  Nuova Asta </a>
                      </div>
                  </div>


                  <div class="card-body ">
                      <ul class="nav nav-tabs">
                          <li class="nav-item abtg__item"><a
                                  :class="activeAll"
                                  @click="listByColorAndCity(city_id,0, city)">
                              <div class="abtg__circle all"></div>
                          </a>
                          </li>
                          <li class="nav-item abtg__item"><a
                                  :class="activeGreen"
                                  @click="listByColorAndCity(city_id,4, city)">
                              <div class="abtg__circle green"></div>
                          </a>
                          </li>
                          <li class="nav-item abtg__item"><a
                                  :class="activeRed"
                                  @click="listByColorAndCity(city_id,1, city)">
                              <div class="abtg__circle red"></div>
                          </a>
                          </li>
                          <li class="nav-item abtg__item"><a
                                  :class="activeYellow"
                                  @click="listByColorAndCity(city_id,2, city)">
                              <div class="abtg__circle yellow"></div>
                          </a>
                          </li>

                          <li class="nav-item abtg__item"><a
                                  :class="activeGrey"
                                  @click="listByColorAndCity(city_id,3, city)">
                              <div class="abtg__circle grey"></div>
                          </a>
                          </li>


                      </ul>
                      <div class="table-responsive">
                          <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded">
                              <thead>
                              <tr>

                                  <th class="mdl-data-table__cell--non-numeric text-left">
                                      <span class="abtg__text-abtg">{{$t('auction.table_archive_label_excerpt')}}</span>
                                  </th>
                                  <th class="mdl-data-table__cell--non-numeric text-left">
                                      <span class="abtg__text-abtg">{{$t('auction.table_archive_label_address')}}</span>
                                  </th>
                                  <th class="mdl-data-table__cell--non-numeric text-left">
                                      <span class="abtg__text-abtg">{{$t('auction.table_archive_label_auction_base')}}</span>
                                  </th>
                                  <th class="mdl-data-table__cell--non-numeric text-left">
                                      <span class="abtg__text-abtg">{{$t('auction.table_archive_label_minimum_offer')}}</span>
                                  </th>
                                  <th class="mdl-data-table__cell--non-numeric text-left">
                                      <span class="abtg__text-abtg">{{$t('auction.table_archive_label_street_price')}}</span>
                                  </th>
                                  <th class="mdl-data-table__cell--non-numeric text-left">

                                  </th>

                              </tr>
                              </thead>
                              <tbody>

                              <tr v-for="(m, index) in auctionArchiveByCityData">
                                  <td class="align-top" v-html="IS_IT_ERASABLE(m.stralciabile)">

                                  </td>
                                  <td class="align-top">
                                      <div  class="abtg__circle" :class="AUCTION_COLOR(m.color)"></div> {{m.city}}<br>
                                      <em v-if="m.indirizzo">{{m.indirizzo}}<br></em>
                                      <strong>{{m.data_asta}}</strong>
                                  </td>
                                  <td class="align-top">
                                      {{m.base_asta | currency}}
                                  </td>
                                  <td class="mdl-data-table__cell--non-numeric align-top">
                                      {{m.offerta_minima | currency}}
                                  </td>
                                  <td class="align-top">
                                      {{m.street_price | currency}}
                                  </td>


                                  <td class="align-top">

                                          <a
                                                  @click="editAuction(m.id)">
                                              <i class="fas fa-list margin-right-10 "></i>
                                          </a>&nbsp;&nbsp;
                                          <a
                                                  @click="goToOperation(m.id)">
                                              <i class="fas fa-calculator margin-right-10"></i>
                                          </a>&nbsp;&nbsp;
                                          <a
                                                  data-toggle="modal" data-target="#exampleModalSingleAuction"
                                                  @click="setIdToDelete(m.id)">
                                              <i class="far fa-trash-alt "></i>
                                          </a>

                                  </td>
                              </tr>
                              </tbody>
                          </table>
                      </div>


                  </div>
              </div>
              <!-- start modal -->
              <div class="modal fade" id="exampleModalSingleAuction" tabindex="-1" role="dialog"
                   aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h4 class="modal-title" id="exampleModalLabel">
                                  {{$t('valutation.valutation_question_title')}}</h4>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                              </button>
                          </div>
                          <div class="modal-body">
                              {{$t('valutation.valutation_question_delete')}}
                          </div>
                          <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                  {{$t('valutation.valutation_label_button_close')}}
                              </button>
                              <button type="button" class="btn btn-success"
                                      @click="deleteSingleAuction()"
                                      data-dismiss="modal">{{$t('valutation.valutation_label_button_delete')}}
                              </button>
                          </div>

                      </div>
                  </div>
              </div>
              <!-- end modal -->


          </div>
      </div>
    </div>
</template>
<script>

    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';
    import Popover from '../commons/popover';

    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, Popover},
        data: function () {
            return {

                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                }
            }
        },

        computed: {

            ...mapFields(['showAuctionListCard', 'auctionList', 'activeRed', 'activeYellow', 'activeGrey', 'activeGreen', 'activeAll', 'auctionArchiveByCityData', 'regionCode', 'city_id', 'city', 'showModal', 'idToDelete', 'formData']),


        },
        created: function () {

        },
        methods: {
            listByColorAndCity: function (city_id, color, city) {
                this.$store.dispatch('auction/auctionListByCity', {city_id: city_id, color: color, city: city});
                this.$store.dispatch('auction/changeTab', color);
            },
            editAuction: function (id) {
                this.$store.dispatch('auction/onOffEditMode', false);
                this.$store.dispatch('auction/editAuction', id);
            },
            openModal() {
                this.formData = [];
                this.$store.dispatch('auction/onOffEditMode', true);
                this.$store.dispatch('auction/openModal');
            },
            goToOperation: function (id) {
                this.$store.dispatch('auction/createOperation', id);

            },
            setIdToDelete: function(id)
            {
                this.idToDelete = id;
            },
            deleteSingleAuction()
            {
                this.$store.dispatch('auction/deleteSingleAuction');
            }
        }
    }
</script>